import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { QuestionCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import * as S from './styles';

export const TooltipHelp = ({ text, style = {}, forceScroll = false }) => {
  const changeLibras = useSelector(state => state.app.changeLibras);

  const getStyle = () => {
    if (text?.length > 300 || forceScroll)
      return {
        overflowY: 'scroll',
        height: forceScroll?.height || '200px',
        width: forceScroll?.width || '900px',
      };
    return {};
  };

  const getTooltipDefault = () => {
    return (
      <S.ContainerIcon id="iconHelp" changeLibras={changeLibras} style={style}>
        <Tooltip title={text} color={'#108ee9'} overlayInnerStyle={getStyle()}>
          <QuestionCircleFilled data-testid="icon tooltip" style={{ color: '#108ee9' }} />
        </Tooltip>
      </S.ContainerIcon>
    );
  };

  const getTooltipAcessibilidade = () => {
    return (
      <S.ContainerAcessibilidade changeLibras={changeLibras}>
        <div className="tooltip">
          <QuestionCircleFilled data-testid="accessibility icon tooltip" style={{ color: '#108ee9' }} />
          <span className="tooltipText">{text}</span>
        </div>
      </S.ContainerAcessibilidade>
    );
  };

  return (
    <>
      {getTooltipAcessibilidade()}
      {getTooltipDefault()}
    </>
  );
};

TooltipHelp.propTypes = {
  style: PropTypes.object,
};

TooltipHelp.defaultProps = {
  // text: '',
  // style: {},
};

export default TooltipHelp;
